import { useNavigate, useParams } from 'react-router-dom'
import '../onboarding/onboarding.css'
import LegalDocContent, { getLegalDocTitle } from '../../components/LegalDocContent'

const SettingsLegalDoc = () => {
  const navigate = useNavigate()
  const { docId } = useParams()
  const title = getLegalDocTitle(docId) || docId || 'Document'
  const onBack = () => navigate('/app/profile/settings/legal')

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div style={{ marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack}>← Back</button>
        </div>
        <h1 className="h1">{title}</h1>
        <LegalDocContent docId={docId} />
      </div>
    </div>
  )
}

export default SettingsLegalDoc
